import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.toggle-po-pdf-custom-field-display.presenters.use-toggle-po-pdf-custom-field-display-presenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  // Angular SETTINGS_PO_PDF_CUSTOM_FIELDS.SUCCESSFUL_UPDATE copy
  successfulUpdate: {
    id: `${scope}.successfulUpdate`,
    defaultMessage: 'Custom field updated successfully',
  },
  // Angular SETTINGS_PO_PDF_CUSTOM_FIELDS.FAILED_UPDATE copy
  failedUpdate: {
    id: `${scope}.failedUpdate`,
    defaultMessage:
      'Something went wrong with updating that custom field. Please try again or contact your system administrator.',
  },
})
